const APIService = require('../../../app/services/ApiService');
const NotificationService = require('../../../app/services/NotificationService');
const ValidationService = require('../../../app/services/ValidationService');

import TranslationService from '../../../app/services/TranslationService';
import Vue from 'vue';

export default Vue.component('cancel-order', {

    props: {
        template:
            {
                type: String,
                default: '#vue-cancel-order',
            },
        orderId: {
            type: Number,
            required: true,
        },
        orderAccessKey: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            isPreChecking: false,
            isCancelling: false,
            showCancel: false,
            cancellationRequested: false,
        };
    },

    /**
     * Initialise the account settings modal
     */
    mounted() {
    },

    computed: {},

    methods: {
        showCancelModal() {
            this.isPreChecking = true;
            APIService.get('/rest/modeherz/shop/orders/cancel/allowed', {
                          orderId: this.orderId,
                          orderAccessKey: this.orderAccessKey,
                      }, { supressNotifications: true })
                      .done(response => {
                          if(response.isAllowed) {
                              this.showCancel = true;
                              Vue.nextTick(() => {
                                  $(this.$refs.orderCancelModal).modal("show");
                              });
                          }else {
                              const message = TranslationService.translate('modeherz::OrderConfirmationPageClient.orderConfirmationCancelOrderRequestErrorMessage');
                              NotificationService.error(message);
                              setTimeout(() => window.location.reload(), 5000);
                          }

                      }).fail((response, status) => {
                          const message = TranslationService.translate('modeherz::OrderConfirmationPageClient.orderConfirmationCancelOrderRequestErrorMessage');
                          NotificationService.error(message);
                          setTimeout(() => window.location.reload(), 5000);
                      })
                      .always(() => {
                          this.isPreChecking = false;
                      });
        },
        closeModal() {
            $(this.$refs.orderCancelModal).modal('hide');
        },
        cancelOrder() {
            this.isCancelling = true;
            APIService.put('/rest/modeherz/shop/orders/cancel', {
                          orderId: this.orderId,
                          orderAccessKey: this.orderAccessKey,
                      }, { supressNotifications: true })
                      .done(response => {
                          this.cancellationRequested = true;
                          this.closeModal();
                          NotificationService.success(
                              TranslationService.translate('modeherz::OrderConfirmationPageClient.orderConfirmationCancelOrderRequestSuccessMessage'),
                          ).closeAfter(5000);
                          document.dispatchEvent(new CustomEvent('onOrderCanceled', {
                              detail: {},
                          }));
                          setTimeout(() => window.location.reload(), 5000);

                      }).fail((response, status) => {
                          const message = TranslationService.translate('modeherz::OrderConfirmationPageClient.orderConfirmationCancelOrderRequestErrorMessage');
                          NotificationService.error(message);
                          setTimeout(() => window.location.reload(), 5000);
                      })
                      .always(() => {
                          this.isCancelling = false;
                      });
        },

    },

});
